export const GRAPHQL_ERROR = "GRAPHQL_ERROR";
export const NETWORK_ERROR = "NETWORK_ERROR";
export const RESET_ERROR = "RESET_ERRROR";
export const NO_WSS_AUTH_ERROR = "NO_WSS_AUTH_ERROR";
